import React, { useEffect, useState } from "react";
import randomIntFromInterval from "@bd-utils/randomIntFromInterval";
import shuffleNames from "@bd-utils/useRandomArrayList";

const NameRoulette = ({ onSelectedPlayer, members, isSpinning, duration }) => {
  const [randomList, setRandomList] = useState([]);
  const [selectedWinner, setSelectedWinner] = useState("");
  const [unChosenWinner, setUnChosenWinner] = useState(members);
  const memberListmultiplied = Array.from(
    { length: 55 },
    (_, index) => members[index % members.length]
  );

  useEffect(() => {
    setUnChosenWinner([...members]);
  }, [members]);

  useEffect(() => {
    if (!isSpinning) {
      return;
    }
    
    const randomList = shuffleNames(unChosenWinner);
    const selectedWinner = randomList[randomList.length - 1];

    const indexToRemove = unChosenWinner.indexOf(selectedWinner);
    setUnChosenWinner([...unChosenWinner.slice(0, indexToRemove), ...unChosenWinner.slice(indexToRemove + 1)]);
    setRandomList(randomList);
    setSelectedWinner(selectedWinner);
    onSelectedPlayer(selectedWinner);
    
    if (unChosenWinner.length === 1) {
      setUnChosenWinner([...members]);
    }
  }, [isSpinning]);

  const displayListName = isSpinning => (
    <div
      className={`v2-wheel-name-roulette__item-container ${
        isSpinning ? "is-spinning" : "is-not-spinning"
      }`}
      style={{
        transition: `all ${isSpinning ? duration : 0}ms ease-in-out`
      }}
    >
      {isSpinning ? (
        memberListmultiplied.map((member, index) => {
          return <p key={index}>{member}</p>;
        })
      ) : (
        <p>{selectedWinner}</p>
      )}
    </div>
  );

  return (
    <div className="v2-wheel-name-roulette">
      <div
        className={`v2-wheel-name-roulette--arrow ${
          isSpinning ? "spinning" : ""
        }`}
      >
        <span />
      </div>
      <div className="v2-wheel-name-roulette__box">
        {displayListName(isSpinning)}
      </div>
      <div
        className={`v2-wheel-name-roulette--arrow ${
          isSpinning ? "spinning" : ""
        }`}
      >
        <span />
      </div>
    </div>
  );
};

export default NameRoulette;
